/* Global quick-add for Smokai product cards rendered outside the product
   carousel. The carousel binds its own capture-phase handler and marks the
   section with data-quick-add-bound, so those buttons are skipped here. */
(function () {
  if (window.smQuickAddBound) return;
  window.smQuickAddBound = true;

  function restoreButton(button, label, delay) {
    window.setTimeout(function () {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      label.textContent = label.dataset.originalText;
    }, delay || 1200);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.card-quickadd-button');

    if (!button) return;
    if (button.closest('[data-quick-add-bound]')) return;

    event.preventDefault();

    var holder = button.closest('[data-quick-add-variant-id]');
    var variantId = holder && holder.dataset.quickAddVariantId;
    var available = holder && holder.dataset.quickAddAvailable === 'true';
    var label = button.querySelector('span') || button;

    if (!variantId || !available || button.disabled) return;

    if (!label.dataset.originalText) {
      label.dataset.originalText = label.textContent;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding…';

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var formData = new FormData();

    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cart && typeof cart.getSectionsToRender === 'function') {
      var sectionIds = cart.getSectionsToRender().map(function (cartSection) {
        return cartSection.id;
      });

      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(addUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (result) {
          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'Unable to add this product.');
          }
          return result;
        });
      })
      .then(function (result) {
        label.textContent = 'Added ✓';

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(result);
        } else {
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { source: 'sm-quick-add', cart: result }
            })
          );
        }

        restoreButton(button, label, 1200);
      })
      .catch(function (error) {
        label.textContent = error.message;
        restoreButton(button, label, 2200);
      });
  }, true);
})();
